import { RoomScene } from "./../RoomScene";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { GUI } from "./GUI";
import { Button } from "../../../utils/Button";
import { AudioManager } from "../../../managers/AudioManager";

export class CardsButtons extends Phaser.GameObjects.Container {

    private showButton: Phaser.GameObjects.Container;
    private hideButton: Phaser.GameObjects.Container;

    private gui: GUI;

    constructor(scene: Phaser.Scene, gui: GUI) {

        super(scene);

        this.visible = false;

        this.scaleX = GameVars.scaleX;
        this.y = GameConstants.GAME_HEIGHT;
        this.x = GameConstants.GAME_WIDTH / 2;

        this.gui = gui;

        // SHOW CARDS

        this.showButton = new Phaser.GameObjects.Container(this.scene, 75, -50);
        this.add(this.showButton);

        let showButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_red.png", "btn_red.png", true);
        showButton.onUp(this.onClickShow, this);
        this.showButton.add(showButton);

        let showText = new Phaser.GameObjects.Text(this.scene, 0, 0, "SHOW CARDS", {fontFamily: "Oswald-Medium", fontSize: "22px", color: "#871947", align: "center"});
        showText.setOrigin(.5);
        this.showButton.add(showText); 

        // HIDE CARDS

        this.hideButton = new Phaser.GameObjects.Container(this.scene, -75, -50);
        this.add(this.hideButton);

        let hideButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_blue.png", "btn_blue.png", true);
        hideButton.onUp(this.onClickHide, this);
        this.hideButton.add(hideButton);

        let hideText = new Phaser.GameObjects.Text(this.scene, 0, 0, "HIDE CARDS", {fontFamily: "Oswald-Medium", fontSize: "22px", color: "#064150", align: "center"});
        hideText.setOrigin(.5);
        this.hideButton.add(hideText);
    }

    private onClickShow(): void {

        AudioManager.playSound("btn_click");

        RoomScene.currentInstance.showCards(true);
        RoomScene.currentInstance.afterShowWinners();
        RoomScene.currentInstance.showBluffBanana();
        this.visible = false; 
    }

    private onClickHide(): void {

        AudioManager.playSound("btn_click");

        RoomScene.currentInstance.afterShowWinners();
        this.visible = false; 
    }
}
